<wtls-filter-bar [filterData]="filtersState" [clinicLocationOptions]="clinicLocationOptions" (filtersChange)="updateFilters($event)"></wtls-filter-bar>